import React from 'react';
import PropTypes from 'prop-types';
import { Badge as BsBadge } from 'react-bootstrap';
import classNames from 'classnames';

const Badge = ({ color, children }) => (
  <BsBadge className={classNames('Badge', color)}>
    { children }
  </BsBadge>
);

Badge.propTypes = {
  color: PropTypes.oneOf(['blue', 'darkgrey', 'green', 'lightgrey', 'red', 'yellow']),
  children: PropTypes.any,
};

Badge.defaultProps = {
  color: 'lightgrey',
  children: null,
};

export default Badge;
